const searchInput = document.getElementById('online-dienst-suche') as HTMLInputElement;

function changeOnlineServiceSearchInput() {
  const list = document.getElementById('online-dienst-list') as HTMLDivElement;
  let matchedResults = 0;
  list.querySelectorAll<HTMLDivElement>('.pmo-entity-box').forEach(function(elem) {
    if (searchInput.value.trim() == '') {
      elem.classList.remove('d-none');
      matchedResults++;
    } else {
      if (elem.dataset.searchFilter.trim().toLowerCase().includes(searchInput.value.trim().toLowerCase())) {
        elem.classList.remove('d-none');
        matchedResults++;
      } else {
        elem.classList.add('d-none');
      }
    }
    if (matchedResults > 0) {
      document.getElementById('online-dienst-list-empty')?.classList.add('d-none');
    } else {
      document.getElementById('online-dienst-list-empty')?.classList.remove('d-none');
    }
  });
}

if (searchInput !== null) {
  searchInput.addEventListener('input', changeOnlineServiceSearchInput);
}
